import React, { useState } from "react";
import api from "../lib/api";
import { Card, Button } from "./ui";
import { errMsg } from "../lib/utils";
import { toast } from "sonner";
import { Search, Save, Download } from "lucide-react";

// Import status invoice dari Excel: Invoice Number, AWB Number, Status (Invoiced/Paid), Paid Date (opsional)
export default function InvoiceStatusImporter() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const call = async (dry) => {
    const fd = new FormData(); fd.append("file", file);
    const r = await api.post(`/invoices/import-numbers${dry ? "?dry_run=true" : ""}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data;
  };
  const runPreview = async () => {
    if (!file) return toast.error("Pilih file dulu");
    setBusy(true); setPreview(null); setResult(null);
    try {
      const d = await call(true);
      setPreview(d); toast.success(`Preview: ${d.marked_paid} Paid · ${d.marked_invoiced} Invoiced`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const runApply = async () => {
    if (!window.confirm(`Tandai ${preview?.marked_paid || 0} AWB Paid & ${preview?.marked_invoiced || 0} AWB Invoiced?\nJurnal piutang/penerimaan otomatis dibuat.`)) return;
    setBusy(true);
    try {
      const d = await call(false);
      setResult(d); toast.success(`✓ ${d.marked_paid} Paid · ${d.marked_invoiced} Invoiced`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const template = async () => {
    try {
      const r = await api.get("/invoices/import-numbers-template", { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a"); a.href = url; a.download = "Template_Import_Status_Invoice.xlsx"; a.click(); URL.revokeObjectURL(url);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const S = result || preview;

  return (
    <Card className="p-5" data-testid="invoice-status-importer">
      <div className="bg-slate-50 border border-slate-200 rounded p-2 text-xs text-slate-700 mb-3">
        Kolom: <b>Invoice Number</b>, <b>AWB Number</b>, <b>Status</b> (Invoiced / Paid), <b>Paid Date</b> (opsional, YYYY-MM-DD).
        Status <b>Paid</b> → AWB jadi Paid + jurnal penerimaan (Dr Kas / Cr Piutang). Status <b>Invoiced</b> → simpan nomor invoice + AWB jadi Invoiced.
        Dicocokkan lewat No AWB. Tahap: Preview (belum disimpan) → Import.
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Button variant="secondary" data-testid="invstatus-template" onClick={template}><Download size={14}/> Template</Button>
        <input type="file" accept=".xlsx,.xls" data-testid="invstatus-file"
          onChange={(e) => { setFile(e.target.files?.[0] || null); setPreview(null); setResult(null); }} className="text-sm"/>
        {!preview && <Button data-testid="invstatus-preview" onClick={runPreview} disabled={busy || !file}><Search size={14}/> {busy ? "Membaca..." : "Preview"}</Button>}
        {preview && !result && <Button data-testid="invstatus-apply" onClick={runApply} disabled={busy}><Save size={14}/> {busy ? "Memproses..." : "Import"}</Button>}
      </div>
      {S && (
        <div className={`mt-3 text-sm rounded px-3 py-2 border ${result ? "bg-emerald-50 border-emerald-200 text-emerald-900" : "bg-sky-50 border-sky-200"}`} data-testid="invstatus-summary">
          <div className="font-bold mb-1">{result ? "✓ Import selesai" : "Preview (belum disimpan)"}</div>
          <div>Paid: <b>{S.marked_paid}</b> · Invoiced: <b>{S.marked_invoiced}</b>{S.skipped ? <> · <span className="text-amber-700">Dilewati: <b>{S.skipped}</b></span></> : null}</div>
          {result && <div className="text-xs mt-1">Jurnal penerimaan dibuat: {result.payment_journals_posted ?? 0} · jurnal piutang: {result.ar_journals_posted ?? 0}</div>}
          {S.errors?.length > 0 && (
            <details className="mt-1">
              <summary className="cursor-pointer text-red-700 text-xs">{S.errors.length + (S.errors_truncated || 0)} baris bermasalah</summary>
              <ul className="text-xs list-disc pl-5 max-h-60 overflow-y-auto">{S.errors.slice(0, 100).map((e, i) => <li key={i}>Baris {e.row}: {e.message}</li>)}</ul>
            </details>
          )}
        </div>
      )}
    </Card>
  );
}
